/*
 * VitaFresh: Herz «Zu den Favoriten» im Shop (Plan Favoriten, T4).
 * Ersetzt das Swish-Herz (Wishlist King). Die Liste liegt im Abo-Worker (D1)
 * hinter dem App-Proxy /apps/abo/api/favoriten.
 *
 * Aufbau: oben reine Logik (testbar mit node --test scripts/vf-favoriten.test.mjs),
 * unten die Anbindung ans DOM. ES2017, kein Build.
 *
 * Öffentlich:
 *   window.vfFavoriten = { laden(): Promise<Set<string>>, setzen(handles, an): Promise<{anzahl}>, eingeloggt }
 *
 * «Meine Favoriten» zeigt seit 11.10.2026 «Mein Konto» (assets/vf-konto.js) über
 * window.vfFavoriten.karten/kaufen/groesseMerken/standardVariante; die alte Liste
 * dieser Datei und der PageFly-Pfad sind am 17.10.2026 entfernt (B1 der Code-Prüfung).
 *
 * Grösse pro Favorit (Abo-Plan 2026-10-01): Das Herz auf der Produktseite schickt
 * die gewählte Variante mit, das Karten-Herz nie. «Meine Favoriten» wählt die
 * gemerkte Grösse vor, ein Wechsel im Grössenfeld merkt sie (POST …/groesse).
 * «In den Warenkorb» setzt vf_quelle = shop-favoriten, wenn noch keine Markierung da ist.
 */
(function (root) {
  'use strict';

  var TEXT_AN = 'Zu den Favoriten';
  var TEXT_AUS = 'Aus den Favoriten entfernen';
  var HINWEIS_FEHLER = 'Das hat gerade nicht geklappt. Bitte versuche es nochmals.';
  var HINWEIS_GESPEICHERT = 'Favorit gespeichert';
  var OFFEN_KEY = 'vf-herz-offen';
  var URL_LISTE = '/apps/abo/api/favoriten';
  var URL_MERKEN = '/apps/abo/api/favoriten/merken';
  var URL_GROESSE = '/apps/abo/api/favoriten/groesse';
  var URL_KONTO = '/apps/abo/api/konto';
  var URL_SEITE = '/apps/abo/api/favoriten/shop';
  var URL_WARENKORB_ADD = '/cart/add.js';
  var GROESSE = { K: 'Klein', M: 'Mittel', G: 'Gross' };
  var HERZ_SVG =
    '<svg class="vf-herz__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  // ---------------------------------------------------------------------------
  // Reine Funktionen
  // ---------------------------------------------------------------------------

  function esc(wert) {
    if (wert === null || wert === undefined) return '';
    return String(wert)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function herzMarkup(handle, mitText) {
    return (
      '<button type="button" class="vf-herz' + (mitText ? ' vf-herz--produkt' : ' vf-herz--karte') +
      '" data-vf-herz="' + esc(handle) + '" aria-pressed="false" aria-label="' + TEXT_AN + '">' +
      HERZ_SVG +
      (mitText ? '<span class="vf-herz__text">' + TEXT_AN + '</span>' : '') +
      '</button>'
    );
  }

  // Shopify-Bot-Schutz liefert HTML, Drosselung 429/430: nie parsen.
  function istJsonAntwort(res) {
    if (!res || res.status === 429 || res.status === 430) return false;
    var typ = res.headers && typeof res.headers.get === 'function' ? res.headers.get('content-type') : '';
    return /^application\/json\b/i.test(String(typ || '').trim());
  }

  function leseJson(res) {
    if (!istJsonAntwort(res)) return Promise.resolve(null);
    return Promise.resolve()
      .then(function () { return res.json(); })
      .catch(function () { return null; });
  }

  // Gewählte Variante auf der Produktseite (Abo-Plan 2026-10-01, E5): Das Herz
  // merkt die Grösse mit. Das Feld id im Bestellformular der Gerichtseite
  // (sections/vf-gericht-main.liquid) folgt dem Grössenwechsel, dann ?variant=.
  // Nur Ziffern, sonst null (dann ohne Grösse wie das Karten-Herz). Liefert die
  // aktuell angezeigte Variante; ob sie gewählt ist, entscheidet erstelleVariantenWahl.
  function gewaehlteVariante(doc, ort) {
    var sel = ['[data-vfg] form[data-type="add-to-cart-form"] [name="id"]', 'form.shopify-product-form [name="id"]'];
    for (var i = 0; i < sel.length; i++) {
      var el = doc && doc.querySelector ? doc.querySelector(sel[i]) : null;
      if (el && /^\d+$/.test(String(el.value || ''))) return String(el.value);
    }
    var m = /[?&]variant=(\d+)/.exec((ort && ort.search) || '');
    return m ? m[1] : null;
  }

  // Nur eine Grösse, die die Kundin auf dieser Seite selbst gewählt hat, zählt
  // (E-a, Koordinator 01.10.2026). Die beim Laden vorgewählte (Gerichtseite: Mittel)
  // nicht. lesen() liefert die angezeigte Variante (gewaehlteVariante). Der erste
  // gelesene Wert ist der Startwert; sobald je ein anderer Wert zu sehen war,
  // gilt die Grösse als gewählt (auch beim Zurückwechseln auf den Startwert).
  function erstelleVariantenWahl(lesen) {
    var start = null;
    var gewechselt = false;
    function beobachten() {
      var v = lesen();
      if (!v) return;
      if (start === null) { start = v; return; }
      if (v !== start) gewechselt = true;
    }
    function gewaehlt() {
      beobachten();
      return gewechselt ? lesen() : null;
    }
    return { beobachten: beobachten, gewaehlt: gewaehlt };
  }

  // Grössenwechsel auf «Meine Favoriten» (E-e): je Handle nacheinander und nur
  // der jüngste Wunsch geht raus, damit die gespeicherte Grösse der zuletzt
  // angezeigten entspricht. Hinweis nur bei gesetzt:true.
  // opt = { setzen(handle, groesse): Promise<{ok,gesetzt}>, hinweis(text) }
  function erstelleGroessenMerker(opt) {
    var kette = {};
    var neueste = {};
    function wahl(handle, groesse, titel) {
      var v = neueste[handle] = (neueste[handle] || 0) + 1;
      var vorher = kette[handle] || Promise.resolve();
      var jetzt = vorher.then(function () {
        if (neueste[handle] !== v) return null; // überholt: gar nicht erst senden
        return opt.setzen(handle, groesse).then(function (r) {
          if (neueste[handle] === v && r && r.gesetzt === true) {
            opt.hinweis((titel || 'Dein Favorit') + ' merkt sich jetzt ' + GROESSE[groesse]);
          }
          return r;
        }, function () {
          if (neueste[handle] === v) opt.hinweis(HINWEIS_FEHLER);
          return null;
        });
      });
      kette[handle] = jetzt.catch(function () {});
      return jetzt;
    }
    return { wahl: wahl };
  }

  // vf_quelle für Käufe aus «Meine Favoriten» (E16 b). Nur wenn noch keine
  // Markierung im Warenkorb steht (eine Portal-Markierung gewinnt). Messung,
  // nie ein Grund, den Kauf aufzuhalten: wirft nie und gibt nach spaetestensMs
  // (Standard 1.5 s) auf, damit «In den Warenkorb» nie an /cart.js hängt.
  function markiereQuelle(holen, spaetestensMs) {
    var ms = typeof spaetestensMs === 'number' ? spaetestensMs : 1500;
    var frist = new Promise(function (fertig) { setTimeout(fertig, ms); });
    var markieren = Promise.resolve()
      .then(function () { return holen('/cart.js', { credentials: 'same-origin', headers: { accept: 'application/json' } }); })
      .then(function (res) { return leseJson(res); })
      .then(function (c) {
        if (!c || (c.attributes && c.attributes.vf_quelle)) return null;
        return holen('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          body: JSON.stringify({ attributes: { vf_quelle: 'shop-favoriten' } }),
        });
      })
      .then(function () {}, function () {});
    return Promise.race([markieren, frist]).then(function () {});
  }

  function loginZiel(ort) {
    var pfad = (ort && ort.pathname ? ort.pathname : '/') + (ort && ort.search ? ort.search : '');
    return '/account/login?return_url=' + encodeURIComponent(pfad);
  }

  function lies(storage, key) {
    try { return storage ? storage.getItem(key) : null; } catch (e) { return null; }
  }
  function schreib(storage, key, wert) {
    try { if (storage) storage.setItem(key, wert); } catch (e) { /* gesperrt: egal */ }
  }
  function loesch(storage, key) {
    try { if (storage) storage.removeItem(key); } catch (e) { /* gesperrt: egal */ }
  }

  function fehler(grund, status) {
    var e = new Error('favoriten:' + grund);
    e.grund = grund;
    e.status = status || 0;
    return e;
  }

  // ---------------------------------------------------------------------------
  // Logik (ohne DOM). opt = { fetch, kunde, storage, ort, weiterleiten, ansicht }
  // ansicht = { zeige(handle, an), verstecke(handle), hinweis(text), anwenden(set, versteckt) }
  // ---------------------------------------------------------------------------

  function erstelleFavoriten(opt) {
    var holen = opt.fetch;
    var eingeloggt = opt.kunde !== null && opt.kunde !== undefined && opt.kunde !== '';
    var ansicht = opt.ansicht || { zeige: function () {}, verstecke: function () {}, hinweis: function () {}, anwenden: function () {} };
    var set = null; // bestätigter Stand vom Server
    var scope = null;
    var ladend = null;
    var versteckt = new Set();
    // Laufende Klicks: handle → gewünschter Zustand. Liegt über `set`, damit ein
    // Neu-Anwenden (MutationObserver) den optimistischen Zustand nicht zurückdreht.
    var laufend = new Map();

    function effektiv() {
      var s = new Set(set || []);
      laufend.forEach(function (an, h) {
        if (an === null) return; // Zielzustand noch offen: bestätigten Stand zeigen
        if (an) s.add(h); else s.delete(h);
      });
      return s;
    }

    function anwenden() {
      ansicht.anwenden(effektiv(), versteckt);
    }

    function scopeRueckfall() {
      return Promise.resolve()
        .then(function () {
          return holen(URL_KONTO, { method: 'GET', credentials: 'same-origin', headers: { accept: 'application/json' } });
        })
        .then(function (res) {
          if (!res.ok) return null;
          return leseJson(res).then(function (d) { return d && d.accountScope ? String(d.accountScope) : null; });
        })
        .catch(function () { return null; });
    }

    function laden(neu) {
      if (!eingeloggt) return Promise.resolve(new Set());
      if (neu) ladend = null;
      if (ladend) return ladend;
      ladend = Promise.resolve()
        .then(function () {
          return holen(URL_LISTE, { method: 'GET', credentials: 'same-origin', headers: { accept: 'application/json' } });
        })
        .then(function (res) {
          if (!res.ok) throw fehler('laden', res.status);
          return leseJson(res).then(function (daten) {
            if (!daten || !Array.isArray(daten.favoriten)) throw fehler('antwort', res.status);
            var kopf = res.headers.get('x-account-scope');
            var s = new Set(daten.favoriten);
            if (kopf) {
              scope = kopf;
              set = s;
              return set;
            }
            // Header fehlt (z. B. vom Proxy verschluckt): Scope über /api/konto holen.
            return scopeRueckfall().then(function (sc) {
              scope = sc;
              set = s;
              return set;
            });
          });
        });
      ladend.catch(function () { ladend = null; });
      return ladend;
    }

    function scopeKopf() {
      var kopf = { 'content-type': 'application/json', accept: 'application/json' };
      if (scope) kopf['X-Account-Scope'] = scope;
      return kopf;
    }

    // variante nur beim Anschalten (Server wertet sie nur bei an:true und genau
    // einem Handle aus); das Karten-Herz schickt nie eine.
    function posten(handles, an, variante) {
      var body = { handles: handles, an: an, quelle: 'shop' };
      if (an && variante) body.variante = String(variante);
      return holen(URL_MERKEN, {
        method: 'POST',
        credentials: 'same-origin',
        headers: scopeKopf(),
        body: JSON.stringify(body),
      });
    }

    function setzenIntern(handles, an, _wiederholt, variante) {
      if (!eingeloggt) return Promise.reject(fehler('nicht_eingeloggt', 401));
      var liste = Array.isArray(handles) ? handles.slice() : [handles];
      var an2 = !!an;
      return laden()
        .then(function () { return posten(liste, an2, variante); })
        .then(function (res) {
          if (res.status === 409 && !_wiederholt) {
            return laden(true).then(function () {
              anwenden(); // neuer Stand (anderes Konto?) auf alle Herzen
              return setzenIntern(liste, an2, true, variante);
            });
          }
          return leseJson(res).then(function (daten) {
            if (!res.ok || !daten || daten.ok !== true) {
              var grund = (daten && (daten.grund || daten.error)) || (istJsonAntwort(res) ? 'status' : 'antwort');
              throw fehler(grund, res.status);
            }
            var verworfen = Array.isArray(daten.verworfen) ? daten.verworfen : [];
            if (set) {
              liste.forEach(function (h) {
                if (verworfen.indexOf(h) !== -1) return;
                if (an2) set.add(h); else set.delete(h);
              });
            }
            return { anzahl: daten.anzahl, verworfen: verworfen };
          });
        });
    }

    // Öffentlich (T5): ändert Liste und alle Herzen der Seite.
    function setzen(handles, an) {
      return setzenIntern(handles, an).then(function (r) {
        anwenden();
        return r;
      });
    }

    function verstecken(handle) {
      versteckt.add(handle);
      ansicht.verstecke(handle);
    }

    function umschalten(handle, variante) {
      if (!handle) return Promise.resolve();
      if (!eingeloggt) {
        schreib(opt.storage, OFFEN_KEY, handle);
        opt.weiterleiten(loginZiel(opt.ort));
        return Promise.resolve();
      }
      if (laufend.has(handle)) return Promise.resolve();
      // Ist der Stand schon geladen, steht das Ziel sofort fest; sonst null
      // (Doppelklick-Sperre, effektiv() überspringt null).
      laufend.set(handle, set ? !set.has(handle) : null);
      var an;
      return laden()
        .then(function (s) {
          an = !s.has(handle);
          laufend.set(handle, an);
          ansicht.zeige(handle, an);
          return setzenIntern([handle], an, false, an ? variante : null);
        })
        .then(function (r) {
          laufend.delete(handle);
          if (r.verworfen.indexOf(handle) !== -1) {
            ansicht.zeige(handle, !an);
            verstecken(handle);
            return;
          }
          ansicht.zeige(handle, an);
        })
        .catch(function (e) {
          laufend.delete(handle);
          if (an !== undefined) ansicht.zeige(handle, !an);
          if (e && e.grund === 'unbekanntes_gericht') verstecken(handle);
          else ansicht.hinweis(HINWEIS_FEHLER);
        });
    }

    // Grösse eines bestehenden Favoriten merken (Grössenfeld auf «Meine
    // Favoriten», E-e). Legt nie einen Favoriten an. → { ok, gesetzt }
    function groesseSetzen(handle, groesse, _wiederholt) {
      if (!eingeloggt) return Promise.reject(fehler('nicht_eingeloggt', 401));
      return laden()
        .then(function () {
          return holen(URL_GROESSE, {
            method: 'POST',
            credentials: 'same-origin',
            headers: scopeKopf(),
            body: JSON.stringify({ handle: handle, groesse: groesse }),
          });
        })
        .then(function (res) {
          if (res.status === 409 && !_wiederholt) {
            return laden(true).then(function () { return groesseSetzen(handle, groesse, true); });
          }
          return leseJson(res).then(function (daten) {
            if (!res.ok || !daten || daten.ok !== true) {
              var grund = (daten && (daten.grund || daten.error)) || (istJsonAntwort(res) ? 'status' : 'antwort');
              throw fehler(grund, res.status);
            }
            return { ok: true, gesetzt: !!daten.gesetzt };
          });
        });
    }

    // Nach Login/Registrierung: das vor dem Login angetippte Herz nachtragen.
    function nachRueckkehr() {
      if (!eingeloggt) return Promise.resolve();
      var handle = lies(opt.storage, OFFEN_KEY);
      if (!handle) return Promise.resolve();
      loesch(opt.storage, OFFEN_KEY);
      return laden()
        .then(function (s) {
          if (s.has(handle)) return null;
          return setzenIntern([handle], true);
        })
        .then(function (r) {
          if (r && r.verworfen.indexOf(handle) !== -1) throw fehler('unbekanntes_gericht');
          ansicht.zeige(handle, true);
          ansicht.hinweis(HINWEIS_GESPEICHERT);
        })
        .catch(function (e) {
          if (e && e.grund === 'unbekanntes_gericht') {
            verstecken(handle);
            return;
          }
          ansicht.hinweis(HINWEIS_FEHLER);
        });
    }

    return {
      eingeloggt: eingeloggt,
      laden: function () { return laden(false).then(function (s) { return new Set(s); }); },
      setzen: setzen,
      umschalten: umschalten,
      groesseSetzen: function (handle, groesse) { return groesseSetzen(handle, groesse); },
      nachRueckkehr: nachRueckkehr,
      anwenden: anwenden,
      scope: function () { return scope; },
    };
  }

  // ---------------------------------------------------------------------------
  // Favoriten-Daten für «Mein Konto» (assets/vf-konto.js über window.vfFavoriten)
  // item = { h, titel, bild, url, varianten: [{ size, id, preis }] }
  // ---------------------------------------------------------------------------

  // Vorwahl (E-i): gemerkte Grösse, sonst Mittel, sonst die erste (bei nur
  // einer Grösse die einzige).
  function standardVariante(varianten, groesse) {
    if (!Array.isArray(varianten) || !varianten.length) return null;
    var i;
    if (groesse) for (i = 0; i < varianten.length; i++) if (varianten[i].size === groesse) return varianten[i];
    for (i = 0; i < varianten.length; i++) if (varianten[i].size === 'M') return varianten[i];
    return varianten[0];
  }

  // GET der Karten-Daten. 401 → Gast; HTML, 429, 430 und alles Kaputte → Fehler.
  function seiteLaden(holen) {
    return Promise.resolve()
      .then(function () {
        return holen(URL_SEITE, { method: 'GET', credentials: 'same-origin', headers: { accept: 'application/json' } });
      })
      .then(function (res) {
        if (res.status === 401) return { status: 'gast' };
        if (!res.ok) return { status: 'fehler' };
        return leseJson(res).then(function (d) {
          if (!d || !Array.isArray(d.items)) return { status: 'fehler' };
          return { status: 'ok', items: d.items, nichtLieferbar: Number(d.nichtLieferbar) || 0 };
        });
      })
      .catch(function () { return { status: 'fehler' }; });
  }

  // Einmalkauf in den Shopify-Warenkorb. → { ok, text? } (text = Shopify-Meldung bei 422)
  function inDenWarenkorb(holen, id) {
    return Promise.resolve()
      .then(function () {
        return holen(URL_WARENKORB_ADD, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
      })
      .then(function (res) {
        if (res.ok) return { ok: true };
        return leseJson(res).then(function (d) {
          var text = d && (typeof d.description === 'string' ? d.description : typeof d.message === 'string' ? d.message : '');
          return text && res.status === 422 ? { ok: false, text: text } : { ok: false };
        });
      })
      .catch(function () { return { ok: false }; });
  }

  var api = {
    TEXT_AN: TEXT_AN,
    TEXT_AUS: TEXT_AUS,
    HINWEIS_FEHLER: HINWEIS_FEHLER,
    HINWEIS_GESPEICHERT: HINWEIS_GESPEICHERT,
    esc: esc,
    herzMarkup: herzMarkup,
    istJsonAntwort: istJsonAntwort,
    loginZiel: loginZiel,
    gewaehlteVariante: gewaehlteVariante,
    erstelleVariantenWahl: erstelleVariantenWahl,
    erstelleGroessenMerker: erstelleGroessenMerker,
    markiereQuelle: markiereQuelle,
    erstelleFavoriten: erstelleFavoriten,
    standardVariante: standardVariante,
    seiteLaden: seiteLaden,
    inDenWarenkorb: inDenWarenkorb,
  };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  // ---------------------------------------------------------------------------
  // DOM-Anbindung (nur im Browser)
  // ---------------------------------------------------------------------------

  var doc = root.document;
  if (!doc || root.vfFavoriten) return;

  function herzenFuer(handle) {
    var alle = doc.querySelectorAll('[data-vf-herz]');
    var treffer = [];
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].getAttribute('data-vf-herz') === handle) treffer.push(alle[i]);
    }
    return treffer;
  }

  function stelle(knopf, an) {
    var soll = an ? 'true' : 'false';
    if (knopf.getAttribute('aria-pressed') !== soll) knopf.setAttribute('aria-pressed', soll);
    var label = an ? TEXT_AUS : TEXT_AN;
    if (knopf.getAttribute('aria-label') !== label) knopf.setAttribute('aria-label', label);
    var text = knopf.querySelector('.vf-herz__text');
    if (text && text.textContent !== label) text.textContent = label;
  }

  var hinweisTimer = null;
  var domAnsicht = {
    zeige: function (handle, an) {
      herzenFuer(handle).forEach(function (k) { stelle(k, an); });
    },
    verstecke: function (handle) {
      herzenFuer(handle).forEach(function (k) { k.hidden = true; });
    },
    hinweis: function (text) {
      var box = doc.getElementById('vf-herz-hinweis');
      if (!box) {
        box = doc.createElement('div');
        box.id = 'vf-herz-hinweis';
        box.className = 'vf-herz-hinweis';
        box.setAttribute('role', 'status');
        box.setAttribute('aria-live', 'polite');
        doc.body.appendChild(box);
      }
      box.textContent = text;
      box.classList.add('is-sichtbar');
      clearTimeout(hinweisTimer);
      hinweisTimer = setTimeout(function () { box.classList.remove('is-sichtbar'); }, 3500);
    },
    anwenden: function (set, versteckt) {
      var alle = doc.querySelectorAll('[data-vf-herz]');
      for (var i = 0; i < alle.length; i++) {
        var h = alle[i].getAttribute('data-vf-herz');
        stelle(alle[i], set.has(h));
        if (versteckt.has(h) && !alle[i].hidden) alle[i].hidden = true;
      }
    },
  };

  var speicher = null;
  try { speicher = root.sessionStorage; } catch (e) { speicher = null; }

  var fav = erstelleFavoriten({
    fetch: function (u, i) { return root.fetch(u, i); },
    kunde: root.vfKunde,
    storage: speicher,
    ort: root.location,
    weiterleiten: function (u) { root.location.assign(u); },
    ansicht: domAnsicht,
  });

  function holenFenster(u, i) { return root.fetch(u, i); }
  var kontoGroessen = null;
  root.vfFavoriten = {
    laden: fav.laden, setzen: fav.setzen, eingeloggt: fav.eingeloggt,
    // «Mein Konto» (assets/vf-konto.js) zeigt dieselbe Liste: Karten-Daten, Kauf und Grösse merken wie «Meine Favoriten».
    karten: function () { return seiteLaden(holenFenster); },
    standardVariante: standardVariante,
    kaufen: function (id) {
      return markiereQuelle(holenFenster).then(function () { return inDenWarenkorb(holenFenster, id); });
    },
    groesseMerken: function (handle, groesse, titel) {
      if (!kontoGroessen) kontoGroessen = erstelleGroessenMerker({ setzen: fav.groesseSetzen, hinweis: domAnsicht.hinweis });
      return kontoGroessen.wahl(handle, groesse, titel);
    },
  };

  var variantenWahl = erstelleVariantenWahl(function () { return gewaehlteVariante(doc, root.location); });
  function wahlBeobachten() { setTimeout(variantenWahl.beobachten, 0); }

  function klick(ev) {
    var ziel = ev.target && ev.target.closest ? ev.target.closest('[data-vf-herz]') : null;
    if (!ziel) return;
    ev.preventDefault();
    ev.stopPropagation();
    // Nur das Produktherz merkt die gewählte Grösse; Karten-Herzen nie (E-a).
    // Und auch dort nur, wenn die Grösse hier gewählt wurde (nicht vorgewählt).
    var variante = ziel.classList.contains('vf-herz--produkt') ? variantenWahl.gewaehlt() : null;
    fav.umschalten(ziel.getAttribute('data-vf-herz'), variante);
  }

  function beobachten() {
    // Nur für Angemeldete: Gäste haben keine Favoriten, neue Herzen bleiben leer (B1, 17.10.2026).
    if (typeof root.MutationObserver !== 'function' || !fav.eingeloggt) return;
    // Ganzer body: die Kollektion tauscht beim Filtern und «Mehr laden» ganze Teilbäume
    // (Section Rendering, vf-kollektion.js), dazu kommt der Schnellansicht-Dialog.
    // Neu anwenden ist billig (nur Attribute vergleichen) und läuft höchstens einmal je 30 ms.
    var raster = doc.body;
    var geplant = false;
    new root.MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      setTimeout(function () {
        geplant = false;
        fav.anwenden();
      }, 30);
    }).observe(raster, { childList: true, subtree: true });
  }

  function start() {
    // Startwert der Produktseite festhalten; Wechsel über Formular-Ereignisse
    // und Zurück/Vor (?variant=) mitbekommen.
    variantenWahl.beobachten();
    doc.addEventListener('change', wahlBeobachten, true);
    doc.addEventListener('input', wahlBeobachten, true);
    doc.addEventListener('click', wahlBeobachten, true);
    root.addEventListener('popstate', wahlBeobachten);
    doc.addEventListener('click', klick, true);
    beobachten();
    if (!fav.eingeloggt) return;
    fav.laden().then(function () { fav.anwenden(); }, function () { /* Herzen bleiben leer */ });
    fav.nachRueckkehr();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : this);
